import './FloatingAddButton.css';
import { useAuth } from '../AuthContext';

function FloatingAddButton({ onOpen }) {
  const { isAdmin, isMember } = useAuth();

  if (!isAdmin && !isMember) return null;

  return (
    <button
      className="floating-add-btn"
      onClick={onOpen}
      aria-label="Add recipe"
      title="Add recipe"
    >
      <span className="floating-add-btn__icon">+</span>
    </button>
  );
}

export default FloatingAddButton;
